import { TextField } from "@material-ui/core"
import PaperBlock from "../../ui/PaperBlock"
import React, { Component } from "react"

class SearchPanel extends Component {
    render() {
        return <PaperBlock style={{display: "flex"}}>
            <TextField 
                style = {{flex: "1 1 auto"}}
                value={this.props.code}
                label="Поиск по коду"
                onChange={this.props.onChange}
            />
        </PaperBlock>
    }
}

export default SearchPanel